import {Component, OnInit, ViewChild} from '@angular/core';
import {DataService} from '../../../Services/data.service';
import { Router } from '@angular/router';
import { StorageService } from '../../../Services/storage.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AppConfigService } from '../../../Services/app-config.service';
import { EodHeaderModel } from '../../../DataModels/eod-header-model';
import { PagerStateService } from '../../../Services/pager-state.service';
import {DataExportService} from '../../../Services/dataExport.service';
import {BsToastService} from '../../../Services/bs-toast-service';
import {Title} from '@angular/platform-browser';
import {DataTableComponent, DataTableColumnConfig} from '../../common/data-table/data-table.component';
import {ListPageBase} from '../../list-page-base';

@Component({
  selector: 'app-pos-data-browser',
  templateUrl: './pos-data-browser-list.component.html',
  styleUrls: ['./pos-data-browser-list.component.css'],
  standalone: false
})
export class PosDataBrowserListComponent extends ListPageBase implements OnInit {
  constructor(
    private table: DataService,
    private storage: StorageService,
    private notification: BsToastService,
    public dataExport: DataExportService,
    private titleService: Title
  ) {
    super();
  }

  // Reference to the shared data table (for Excel export)
  @ViewChild(DataTableComponent) commonTable?: DataTableComponent;

  gridIsReady = false;
  apiController = '';
  dataSetFlag = 0;
  datasetName = '';
  exportDT: Date;
  selectedBDay = '';
  selectedStore = '';
  eod: EodHeaderModel;
  PosDataCount = 0;
  eodCount = 0;
  itemSalesCount = 0;
  currencyCount = 0;
  isLoaded = false;
  dayList: Array<EodHeaderModel> = [];
  storeList: Array<EodHeaderModel> = [];

  isLoading = false;

  vm: any = {
    list: [],
  };

  // Paging
  datasetType = 0; // 0 = Menu Item Sales, 1 = Item Sales

  ngOnInit(): void {
    this.titleService.setTitle($localize`:POS Data Browser@@posDataBrowser:POS Data Browser`);
    this.vm.list = [];
    // Initial fill of business days and stores
    this.getBusinessDayData();
  }

  // Paging/State
  // EVENT handlers from selects
  onChangeBDay(event: any): void {
    const newVal = event?.target?.value;
    this.selectedBDay = newVal;
    this.storeList = []; // clear store list because date change
    this.getStoresForBDate();
  }

  onChangeStore(event: any): void {
    const newVal = event?.target?.value;
    this.selectedStore = newVal;
  }

  onChangeDataset(event: any): void {
    const val = Number(event?.target?.value);
    this.datasetType = isNaN(val) ? 0 : val;
    // Clear list on dataset change to avoid column/data mismatch until next fetch
    if (this.isLoaded) {
      this.vm.list = [];
      this.totalRecords = 0;
      this.startIndex = 0;
      this.endIndex = 0;
      this.isLoaded = false;
    }
  }

  // Excel export using the shared table
  excelBtnOnClick(): void {
    const currentDate = new Date().toDateString();
    const tableEl = this.commonTable?.getTableElement();
    if (!tableEl) {
      return;
    }
    this.dataExport.exportToExcel(tableEl, 'POS_Data ' + currentDate + '.xlsx', currentDate);
  }

  onClose(): void {
    this.router.navigate(['home']).then();
  }

  // Server calls ---------------------------------------------------------------------------------
  getStoresForBDate(): void {
    this.table.getData('EODHeaders').subscribe({
      next: (result) => {
        this.storeList = result;
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }

  getBusinessDayData(): void {
    this.table.getData('EODHeaders').subscribe({
      next: (result) => {
        this.dayList = result;
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData(): void {
    this.isLoading = true;

    if (this.datasetType === 0) {
      this.apiController = 'MenuItemSales';
    } else if (this.datasetType === 1) {
      this.apiController = 'ItemSales';
    } else {
      this.apiController = '';
    }

    if (!this.apiController || !this.selectedStore || !this.selectedBDay) {
      this.isLoading = false;
      return;
    }

    this.datasetName = this.apiController;

    this.table.getData(
      this.apiController,
      '?storeCode=' + this.selectedStore + '&eodHeaderBusinessDate=' + this.selectedBDay
    ).subscribe({
      next: (result) => {
        // Some endpoints return { Data, totalRecords }, others raw array
        const data = (result && (result as any).Data) ? (result as any).Data : result;
        this.vm.list = Array.isArray(data) ? data : [];
        this.totalRecords = this.vm.list.length;
        this.eodCount = this.vm.list.length;
        this.isLoaded = true;
        this.paginate(false);
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });

    this.getItemSalesSummaryData(this.datasetType);
  }

  getItemSalesSummaryData(value: number) {
    // Placeholder for future charting; maintain previous call shape
    if (value === 0) {
      this.apiController = 'MenuItemSales';
    } else if (value === 1) {
      this.apiController = 'ItemSales';
    }

    this.table.getData(this.apiController, '?fromdate=' + '01-01-2019' + '&todate=' + '01-03-2019').subscribe({
      next: (_result) => {
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }

  onNavigate(aID: string): void {
    // No-op for now; wire to detail route if needed
  }

  // Columns for the shared table ------------------------------------------------------------------
  private get menuItemSalesColumns(): DataTableColumnConfig[] {
    return [
      {header: $localize`:Date@@date:Date`, field: 'BusinessDate', pipe: 'date', dateFormat: 'MM/dd/yyyy'},
      {header: $localize`:Code@@code:Code`, field: 'MenuItemCode'},
      {header: $localize`:Sold In Pkg@@soldInPkg:Sold In Pkg`, field: 'SoldInPackageIndicator'},
      {header: $localize`:Description@@description:Description`, field: 'MenuItemDescription'},
      {header: $localize`:Adjustment Type@@adjType:Adj Type`, field: 'AdjustmentType'},
      {header: $localize`:Sell Price@@sellPrice:Sell Price`, field: 'SellingPrice', pipe: 'decimal'},
      {header: $localize`:Standard Price@@stdPrice:Std Price`, field: 'StandardPrice', pipe: 'decimal'},
      {header: $localize`:Quantity Sold@@qtySold:Qty Sold`, field: 'NumberSold'},
      {header: $localize`:Quantity Waste@@qtyWaste:Qty Waste`, field: 'NumberWasted'},
      {header: $localize`:Category@@category:Category`, field: 'CategoryCode'},
      {header: $localize`:Desc@@desc:Desc`, field: 'CategoryDescription'},
      {header: $localize`:Sales Item Ref@@salesItemRef:Sales Item Ref`, field: 'SalesItemReference'},
      {header: $localize`:Category 2 Code@@cat2Code:Cat 2 Code`, field: 'Category2Code'},
      {header: $localize`:Category 2 Description@@cat2Desc:Cat 2 Desc`, field: 'Category2Description'},
    ];
  }

  private get itemSalesColumns(): DataTableColumnConfig[] {
    return [
      {header: $localize`:Business Day@@bus:Bus Day`, field: 'BusinessDate', pipe: 'date', dateFormat: 'MM/dd/yyyy'},
      {header: $localize`:Register Number@@regNumber:Reg #`, field: 'RegisterNumber'},
      {header: $localize`:Store@@store:Store`, field: 'StoreCode'},
      {header: $localize`:Item@@item:Item`, field: 'ItemCode'},
      {header: $localize`:Description@@description:Description`, field: 'ItemDescription'},
      {header: $localize`:Sell@@sell:Sell`, field: 'SellPrice', pipe: 'decimal'},
      {header: $localize`:Disc@@disc:Disc`, field: 'DiscountApplied', pipe: 'decimal'},
      {header: $localize`:Net Sell@@netSell:Net Sell`, field: 'NetSellPrice', pipe: 'decimal'},
      {header: $localize`:Quantity Sold@@qtySold:Qty Sold`, field: 'QtySold'},
      {header: $localize`:Ext Code@@extCode:Ext Code`, field: 'ExternalCode'},
      {header: $localize`:Date@@date:Date`, field: 'SaleDateTime', pipe: 'date', dateFormat: 'MM/dd/yyyy'},
      {header: $localize`:Order Number@@ordNumber:Ord #`, field: 'OrderNumber'},
      {header: $localize`:Sequence Number@@seqNumber:Seq #`, field: 'SequenceNumber'},
      {header: $localize`:Type@@type:Type`, field: 'LineType'},
      {header: $localize`:Server@@server:Server`, field: 'ServerName'},
      {header: $localize`:ServerNumber@@serverNumber:Server #`, field: 'ServerId'},
      {header: $localize`:Posted@@posted:Posted`, field: 'PostedToAccting'},
    ];
  }

  public get columns(): DataTableColumnConfig[] {
    return this.datasetType === 0 ? this.menuItemSalesColumns : this.itemSalesColumns;
  }
}
